"use client";

import { Animated } from "../animated";
import { Banner } from "./banner";
import { TheChallengeSolution } from "./the-challenge-solution";
import { CTA } from "./cta";
import { RealWorldSolutionsSection } from "../nsw-water-compliance/real-world-solutions";
import { SectionSeparator } from "../shared";
import { HowItWorks } from "./how-it-works";

export default function ACTEnvironmentalAssessmentPage() {
  return (
    <Animated>
      <Banner />
      <TheChallengeSolution />
      <SectionSeparator
        imageUrl="/images/act-terrakio.webp"
        dataSpeed="0.05"
        overlayClassName="from-black/10 to-black/40"
        imageClassName="lg:mt-108"
      />
      <HowItWorks />
      <SectionSeparator
        imageUrl="/images/act-land-use.webp"
        dataSpeed="0.05"
        overlayClassName="from-black/10 to-black/40"
      />
      <RealWorldSolutionsSection />
      <CTA />
    </Animated>
  );
}
